// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--6e62f";
export var map = "styles-module--map--4a934";